import { render, staticRenderFns } from "./SeasonTagger.vue?vue&type=template&id=60e69ecb&scoped=true"
import script from "./SeasonTagger.vue?vue&type=script&lang=js"
export * from "./SeasonTagger.vue?vue&type=script&lang=js"
import style0 from "./SeasonTagger.vue?vue&type=style&index=0&id=60e69ecb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e69ecb",
  null
  
)

export default component.exports